export default __webpack_public_path__ + "static/media/green-check.1d842405.svg";